import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "OutsideSalesPage",

	metaInfo: { title: "Outside Sales" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Customers",
				to: { name: "customers" }
			},
			{
				title: "Salesmen",
				to: { name: "salesmen" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
